var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-section',{attrs:{"title":"Ci occupiamo noi del tuo check-in","background_color":_vm.sass('selected')}},[_c('div',{staticClass:"check-in-status"},[_vm._l((_vm.visible_flights),function(flight,index){return _c('div',{key:`${flight.request_id}:${index}`,staticClass:"check-in-status__container",class:{
        'check-in-status__container--bordered':
          index < _vm.visible_flights.length - 1,
      }},[_c('flight-check-in-status',{attrs:{"flight":flight,"is_homogenous_state":_vm.is_homogenous_state}})],1)}),(_vm.visible_flights.length === 0)?_c('flight-check-in-status',{attrs:{"flight":{
        status: _vm.status_summary,
        boarding_passes: [],
      },"is_homogenous_state":""}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }